import React from 'react';
import { Button } from './ui/Button';
export function Hero() {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/50689925929?text=Hola,%20necesito%20información%20sobre%20certificación%20de%20Gas%20LP', '_blank');
  };
  const handleScheduleClick = () => {
    const formElement = document.getElementById('lead-form');
    formElement?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full bg-gradient-to-br from-gray-900 via-gray-800 to-jazugas-blue py-24 md:py-32 px-4 overflow-hidden" data-id="element-21">
      {/* Background overlay pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-22">
        <div className="absolute inset-0" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }} data-id="element-23"></div>
      </div>

      <div className="relative max-w-5xl mx-auto text-center" data-id="element-24">
        {/* Premium badge */}
        <div className="inline-flex items-center gap-2 bg-jazugas-gold text-black px-6 py-2 rounded-full font-bold text-sm mb-8 shadow-lg" data-id="element-25">
          <span className="text-lg" data-id="element-26">⚡</span>
          <span data-id="element-27">#1 en Costa Rica</span>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-28">
          Certificaciones de Gas LP para el Ministerio de Salud en Costa Rica
        </h1>

        <p className="text-xl md:text-2xl text-gray-200 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-29">
          Líderes en certificación, instalaciones, correcciones, mantenimiento y
          construcción de sistemas de Gas LP. Atención profesional y rápida.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-30">
          <Button variant="primary" size="lg" onClick={handleWhatsAppClick} aria-label="Cotizar por WhatsApp" data-id="element-31">
            Cotizar por WhatsApp
          </Button>
          <Button variant="secondary" size="lg" onClick={handleScheduleClick} aria-label="Agendar visita o evaluación" className="bg-white/10 border-white text-white hover:bg-white hover:text-jazugas-blue" data-id="element-32">
            Agendar visita / evaluación
          </Button>
        </div>

        {/* Trust indicators */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 text-white" data-id="element-33">
          <div className="text-center" data-id="element-34">
            <div className="text-3xl font-bold text-jazugas-gold mb-1" data-id="element-35">15+</div>
            <div className="text-sm text-gray-300" data-id="element-36">Años de experiencia</div>
          </div>
          <div className="text-center" data-id="element-37">
            <div className="text-3xl font-bold text-jazugas-gold mb-1" data-id="element-38">
              100%
            </div>
            <div className="text-sm text-gray-300" data-id="element-39">Certificados aprobados</div>
          </div>
          <div className="text-center" data-id="element-40">
            <div className="text-3xl font-bold text-jazugas-gold mb-1" data-id="element-41">
              24/7
            </div>
            <div className="text-sm text-gray-300" data-id="element-42">Atención WhatsApp</div>
          </div>
          <div className="text-center" data-id="element-43">
            <div className="text-3xl font-bold text-jazugas-gold mb-1" data-id="element-44">
              Costa Rica
            </div>
            <div className="text-sm text-gray-300" data-id="element-45">Cobertura completa</div>
          </div>
        </div>
      </div>
    </section>;
}